/*
 * An address that has to wrap in a narrow column breaks before the `@`, so
 * the two halves stay readable instead of splitting mid-name.
 */
export function EmailWithBreak({ email }: { email: string | null }) {
  if (!email) {
    return null;
  }

  const at = email.indexOf('@');
  if (at <= 0) {
    return email;
  }

  return (
    <>
      {email.slice(0, at)}
      <wbr />
      {email.slice(at)}
    </>
  );
}
